var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-cars-container",attrs:{"id":"part_recommend"}},[(_vm.car.recommend && _vm.car.recommend.length)?_c('p',{staticClass:"title"},[_vm._v("更多推荐")]):_vm._e(),_c('ul',{staticClass:"recommend-cars car-list-wrapper"},_vm._l((_vm.car.recommend),function(item,index){return _c('li',{directives:[{name:"sd-exp",rawName:"v-sd-exp:VehicleDetailExpo",value:({
				page: '二手车车辆详情页',
				label_name: _vm.car.$$track_label_name,
				tag: _vm.car.$$track_tags,
				module_name: '更多推荐',
				position_rank: 7,
				position_in_rank: index + 1,
				position_in_number: 1,
				track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
			}),expression:"{\n\t\t\t\tpage: '二手车车辆详情页',\n\t\t\t\tlabel_name: car.$$track_label_name,\n\t\t\t\ttag: car.$$track_tags,\n\t\t\t\tmodule_name: '更多推荐',\n\t\t\t\tposition_rank: 7,\n\t\t\t\tposition_in_rank: index + 1,\n\t\t\t\tposition_in_number: 1,\n\t\t\t\ttrack_sign: 'aMall.b4307.exposure.VehicleDetailExpo'\n\t\t\t}",arg:"VehicleDetailExpo"},{name:"sd-clk",rawName:"v-sd-clk:VehicleDetailClick",value:({
				page: '二手车车辆详情页',
				label_name: _vm.car.$$track_label_name,
				tag: _vm.car.$$track_tags,
				module_name: '更多推荐',
				button_name: '更多推荐',
				position_rank: 7,
				position_in_rank: index + 1,
				position_in_number: 1,
				track_sign: 'aMall.b4307.click.VehicleDetailClick'
			}),expression:"{\n\t\t\t\tpage: '二手车车辆详情页',\n\t\t\t\tlabel_name: car.$$track_label_name,\n\t\t\t\ttag: car.$$track_tags,\n\t\t\t\tmodule_name: '更多推荐',\n\t\t\t\tbutton_name: '更多推荐',\n\t\t\t\tposition_rank: 7,\n\t\t\t\tposition_in_rank: index + 1,\n\t\t\t\tposition_in_number: 1,\n\t\t\t\ttrack_sign: 'aMall.b4307.click.VehicleDetailClick'\n\t\t\t}",arg:"VehicleDetailClick"}],staticClass:"normal",on:{"click":function($event){return _vm.enterDetail(item)}}},[_c('car-item',{attrs:{"theme":"normal","car":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }